import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import styles from './index.scss';
import Confirmation from '../../components/class-confirmation/index';
import { Tick } from '../../helpers/icon-dictionary';
import messages from './messages';
import { CARRY_OVER_TASK_TYPE } from '../../containers/edit-class/actions';
import withModal from '../with-modal';
import productEnum from '../../helpers/product-enum';

class ChangeCourseConfirmation extends Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose() {
        const { closeChangeCourse } = this.props;
        closeChangeCourse();
    }

    render() {
        const findByKey = (needle, haystack) => haystack.find(x => x.key === needle);

        const {
            assignedCourseId,
            assignedUpfCourseId,
            assignedNewCourseId,
            changeCourseAssignedTasks,
            changeCourseSubmittedFields,
            changeCourseTaskActionType,
            classroomDetail,
            groupId,
            intl,
            isChangingCourseCarryOverSuccess
        } = this.props;

        const isMathletics = (this.props.selectedProduct.id === productEnum.MATHLETICS.id);
        const { yearGroup } = changeCourseSubmittedFields;
        const coursesKey = 'courses';
        const yearGroupsKey = 'yearGroups';
        const assignedCourse = findByKey(assignedCourseId, this.props[coursesKey]);
        const assignedNewCourse = this.props.newCourses.find(newCourse => newCourse.id.toString() === assignedNewCourseId);

        const assignedUPFCourse = this.props.upfCourses.find(upfCourse => upfCourse.id.toString() === assignedUpfCourseId.toString());
        const { value: yearGroupLabel } = findByKey(yearGroup, this.props[yearGroupsKey]);

        const { classroomGroups } = classroomDetail;
        const currentGroup = classroomGroups.find(group => group.id === groupId);

        let updatedActivities = '';
        if (isChangingCourseCarryOverSuccess && changeCourseTaskActionType === CARRY_OVER_TASK_TYPE) {
            const carryOverMessage = intl.formatMessage(messages.activityUpdated,
                { length: changeCourseAssignedTasks.length });
            updatedActivities = (<div><br /> {carryOverMessage}</div>);
        }
        return (
            <Confirmation
                handleOnCloseModal={this.handleClose}
                icon={Tick}>
                <span className={styles.course}>{currentGroup.name}</span> {intl.formatMessage(messages.assignedTo)} <span className={styles.course}>{assignedCourse.value}</span>
                <span>{isMathletics && assignedUPFCourse && <span>, <span className={styles.course}>{assignedUPFCourse.name}</span></span>}</span>
                <span>{isMathletics && assignedNewCourse && <span>& <span className={styles.course}>{assignedNewCourse.name}</span></span>}</span>
                {` (${yearGroupLabel})`}
                {updatedActivities}
            </Confirmation>
        );
    }
}


ChangeCourseConfirmation.propTypes = {
    assignedCourseId: PropTypes.string,
    assignedUpfCourseId: PropTypes.string,
    assignedNewCourseId: PropTypes.string,
    changeCourseAssignedTasks: PropTypes.array,
    changeCourseSubmittedFields: PropTypes.object,
    changeCourseTaskActionType: PropTypes.string,
    classroomDetail: PropTypes.object,
    closeChangeCourse: PropTypes.func,
    groupId: PropTypes.number,
    intl: intlShape.isRequired,
    isChangingCourseCarryOverSuccess: PropTypes.bool,
    upfCourses: PropTypes.array,
    newCourses: PropTypes.array,
    selectedProduct: PropTypes.object
};

const StyledChangeCourse = injectIntl(
    styleable(styles)(ChangeCourseConfirmation)
);

export default withModal('isActive')(StyledChangeCourse);



// WEBPACK FOOTER //
// ./app/components/change-course/confirmation.js